import { Directive, ElementRef, AfterViewInit, Input, OnDestroy } from '@angular/core';

@Directive({
  selector: '[testTooltip]'
})
export class TestTooltipDirective implements AfterViewInit, OnDestroy {
  @Input() testTooltip: string = '';

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    console.log('Test tooltip directive initialized');
    const element = this.el.nativeElement;
    
    // Add test tooltip
    element.setAttribute('matTooltip', this.testTooltip || 'Test tooltip working!');
    element.setAttribute('matTooltipPosition', 'above');
    element.setAttribute('title', this.testTooltip || 'Test tooltip working!');
    element.style.cursor = 'help';
    element.style.backgroundColor = 'yellow';
    
    console.log('Test tooltip applied:', this.testTooltip || 'Test tooltip working!');
  }

  ngOnDestroy() {
    console.log('Test tooltip directive destroyed');
  }
} 